module.exports = __webpack_public_path__ + "static/media/unplug.503890fa.svg";